// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translations directly (optional - can also use HTTP backend)
import translationPT from './locales/pt-BR/translation.json';
import translationEN from './locales/en-US/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
    'pt-BR': {
        translation: translationPT
    },
    'en-US': {
        translation: translationEN
    },
    'ar': {
        translation: translationAR
    }
};

i18n
    // Load translations from backend (optional)
    .use(Backend)
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next
    .use(initReactI18next)
    // Init i18next
    .init({
        resources,
        fallbackLng: 'pt-BR',
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false, // React already safes from XSS
        },

        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },

        react: {
            useSuspense: false,
        },
    });

export default i18n;